import type { RiskAssessmentResultConfig } from '@risksmart-app/domain/src/types';
import type { InsertRiskAssessmentResultConfigMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetLatestRiskAssessmentResultConfigDocument,
  GetRiskAssessmentResultConfigByIdsDocument,
  InsertRiskAssessmentResultConfigDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertRiskAssessmentResultConfigInput = {
  variables: { Config: RiskAssessmentResultConfig; Type: string };
};

export const useInsertRiskAssessmentResultConfig = createMutationHook({
  name: 'mutate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.riskAssessmentResultConfig.insert.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertRiskAssessmentResultConfigInput) => ({
    Config: input.variables.Config,
    Type: input.variables.Type as
      | 'risk_assessment'
      | 'oversight'
      | 'internal_audit',
  }),
  invalidate: (trpc) => [
    trpc.frontend.riskAssessmentResultConfig.getLatest.queryKey(),
    trpc.frontend.riskAssessmentResultConfig.getByIds.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
    Version: number;
    IsLatest: boolean;
  }): InsertRiskAssessmentResultConfigMutation => ({
    insertRiskAssessmentResultConfigApi: {
      __typename: 'InsertRiskAssessmentResultConfigApiOutput',
      Id: result.Id,
      Version: result.Version,
      IsLatest: result.IsLatest,
    },
  }),
  graphqlDocument: InsertRiskAssessmentResultConfigDocument,
  graphqlVariables: (input: InsertRiskAssessmentResultConfigInput) => ({
    ...input.variables,
  }),
  refetchQueries: [
    {
      query: GetLatestRiskAssessmentResultConfigDocument,
      variables: { Type: 'risk_assessment' },
    },
    { query: GetRiskAssessmentResultConfigByIdsDocument },
  ],
});
